"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// components/formBuilder/FormBuilderLayout.tsx
const react_dnd_1 = require("react-dnd");
const react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
const FormSettingsContext_1 = require("../../context/FormSettingsContext");
const UserInterface_1 = require("./UserInterface");
const SessionBuilderContext_1 = require("../../context/SessionBuilderContext");
const FormBuilderLayout = () => {
    const { generatedCode } = (0, SessionBuilderContext_1.useSessionBuilder)();
    return ((0, jsx_runtime_1.jsx)(FormSettingsContext_1.FormSettingProvider, { sessionActiveCode: generatedCode, children: (0, jsx_runtime_1.jsx)(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend, children: (0, jsx_runtime_1.jsx)(UserInterface_1.UserInterface, {}) }) }));
};
exports.default = FormBuilderLayout;
